<template>
    <div class="tabs_content" v-if="!loading">
        <section>
            <div class="status"><h2 v-translate>Přiřazené služby</h2><h2>&nbsp;({{ biller.services.length }})</h2></div>

            <div class="table_overflow">
              <table class="vypis">
                <thead>
                    <tr v-if="biller.services && biller.services.length > 0">
                      <th class="no_padding drag_drop"></th>
                      <th class="no_padding checkbox"></th>
                      <sorting-table-title
                          v-for="title in sortingTableTitles"
                          :key="title.id"
                          :column="title.column"
                          :sort="getActiveSort(title.column)"
                          :extra-style="title.style"
                          @changeSorting="changeSorting"
                      >{{ title.name }}
                      </sorting-table-title>
                      <th class="no_padding"></th>
                    </tr>
                </thead>
                <tr v-for="entity in entities" :key="entity.id" :class="{'clickable': $_loggedUser_action_allowed('subscribers')}" @click.stop="showServiceDetail(entity.id)">
                  <td class="no_padding drag_drop"><span></span></td>
                  <td class="no_padding">
                    <input type="checkbox"
                           :id="entity.id"
                           :value="entity.id"
                           v-model="selectedEntities"
                           @click.stop
                    />
                    <label :for="entity.id" @click.stop v-translate>Vybrat</label>
                  </td>
                  <td data-th="Id služby">{{ entity.id_remote }}</td>
                  <td data-th="Jméno služby">{{ entity.name }}</td>
                  <td data-th="Jméno odběratele">
                    <entity-link :id="entity.id_subscriber" type="subscriber">{{ entity.name_subscriber }}</entity-link>
                  </td>
                  <td data-th="Aktivní od" v-html="$_date_format(entity.active_from)"></td>
                  <td data-th="Aktivní do" v-html="$_date_format(entity.active_to)"></td>
                  <td data-th="Vytvořeno" v-html="$_date_formatFull(entity.timestamp_created)"></td>
                  <td class="no_padding"></td>
                </tr>
                <tr v-if="!biller.services || biller.services.length === 0">
                    <td colspan="8">{{ $gettext("Plátcům odběratele nejsou přiřazeny žádné služby.") }}</td>
                </tr>
            </table>
            </div>
          <local-list-action-line
              :entities="entities"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              @select-all="toggleSelectAll"
              @run-multiple-action="runMultipleAction"
          ></local-list-action-line>
        </section>
    </div>
</template>

<script>
import SortingTableTitle from "../../../common/SortingTableTitle";
import localTable from "@/components/mixins/local-table"
import EntityLink from "../../../common/EntityLink.vue";

export default {
    name: "ServiceList",
    components: { EntityLink, SortingTableTitle},
    props: ["biller", "loading"],
    mixins: [localTable],
    data () {
        return {
            moduleName: "billerServiceList",
        }
    },
    computed: {
      sortingTableTitles() {
        return [
          {id: 1, name: this.$gettext('ID služby'), column: 'id_remote', style: {minWidth: '110px'}},
          {id: 2, name: this.$gettext('Jméno služby'), column: 'name'},
          {id: 3, name: this.$gettext('Jméno odběratele'), column: 'name_subscriber'},
          {id: 4, name: this.$gettext('Aktivní od'), column: 'active_from'},
          {id: 5, name: this.$gettext('Aktivní do'), column: 'active_to'},
          {id: 6, name: this.$gettext('Vytvořeno'), column: 'timestamp_created'}
        ]
      },
      entities() {
        return this.biller.services.sort(this.getSortingFunction());
      },
      csvHeaders(){
        let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
        headers.timestamp_created.callback = (entity) => {return entity.timestamp_created ? this.$_datetime_format(entity.timestamp_created) : ''; };

        return headers;
      },
    },
    methods: {
        getDefaultSorting() {
            return {column: 'name', direction: 'asc' };
        },
        getSortingFunction() {
            return (serviceA, serviceB) => {
                let sortResult = 0;

                switch (this.sort.column) {
                    case 'id_remote':
                    case 'name':
                    case 'name_subscriber':
                        sortResult = this.stringCompare(serviceA[this.sort.column], serviceB[this.sort.column]);
                        break;
                    case 'active_from':
                    case 'active_to':
                    case 'timestamp_created':
                        sortResult = this.integerCompare(serviceA[this.sort.column], serviceB[this.sort.column]);
                        break;
                }

                return this.sort.direction === "asc" ? sortResult : (-1) * sortResult;
            }
        }
    },
}

</script>



// WEBPACK FOOTER //
// src/components/views/billers/billerDetail/ServiceList.vue